import Link from "next/link";
import getConfig from "next/config";

import Price from "@components/Price";
import Status from "@components/Status";
import AddToCart from "@containers/Catalog/Actions/AddToCart";
import Ratings from "@components/Ratings";
import ProductCardLabel from "@components/ProductCardLabel";
import ProductListImage from "@components/ProductList/ProductListImage";
import ProductListTitle from "@components/ProductList/ProductListTitle";
import AddToCompare from "@containers/Catalog/Actions/AddToCompare";
import AddToWishlist from "@containers/Catalog/Actions/AddToWishlist";
import ProductListVariations from "@components/ProductList/ProductListVariations";
import { productHelper } from "@lib/helpers";
import Button from "@components/Button";
import ProductFinancing from "@components/ProductFinancing";

const {
  publicRuntimeConfig: { settings, credex, oney },
} = getConfig();

const AppleFeaturedCategoryProductCard = ({ product }) => {
  const {
    url_key,
    sku,
    thumbnail,
    name,
    regular_price,
    lowest_price,
    msrp_price,
    price,
    discount_type,
    reviews_value,
    reviews_count,
    variations_info,
  } = product;

  const {
    isDisabled,
    isSaleable,
    isWestaco,
    hasStorePickup,
    isInSpecialCampaign,
    hasPricePerFactor,
    hasPriceUnit,
    isVirtualService,
    isLocalSeller,
    getLabels,
  } = productHelper(product);

  const hasVariationsInfo = variations_info?.size > 1;
  const hasFinancingOptions = Boolean(
    isLocalSeller &&
      product.installments_price > 0 &&
      ((credex.isEnabled && !isVirtualService) || oney.isEnabled)
  );

  return (
    <div className="Product flex flex-col relative hover:shadow-mixRedYellow">
      <Link href={`/${url_key}/cpd/${sku}/`}>
        <a title="">
          <ProductListImage thumbnail={thumbnail} name={name} />
        </a>
      </Link>

      <Link href={`/${url_key}/cpd/${sku}/`}>
        <a title="">
          <ProductListTitle name={name} />
        </a>
      </Link>

      {!isDisabled && (
        <>
          {getLabels().length >= 1 && isInSpecialCampaign && (
            <div className="absolute top-0 right-0 h-auto w-auto flex flex-col items-end truncate max-w-[75%]">
              {getLabels()
                .slice(0, 1)
                .map(({ title, variant }, index) => (
                  <>
                    <ProductCardLabel
                      key={`${title}-${index}`}
                      variant={variant}
                      className="truncate max-w-full"
                    >
                      {title}
                    </ProductCardLabel>

                    <div className="p-0.5">
                      <img
                        src={`${settings.websiteStatics}/images/oferta-de-black-friday-listing.svg`}
                        alt="oferta de black friday"
                      />
                    </div>
                  </>
                ))}
            </div>
          )}

          {getLabels().length >= 1 && !isInSpecialCampaign && (
            <div className="absolute top-0 right-0 h-auto w-auto flex flex-col items-end truncate max-w-[75%]">
              {getLabels().map(({ title, variant }, index) => (
                <ProductCardLabel
                  key={`${title}-${index}`}
                  variant={variant}
                  className="truncate max-w-full"
                >
                  {title}
                </ProductCardLabel>
              ))}
            </div>
          )}

          {getLabels().length !== 0 && isInSpecialCampaign && (
            <div className="absolute top-0 right-0 h-auto w-auto flex flex-col items-end truncate max-w-[75%] p-0.5">
              <img
                src={`${settings.websiteStatics}/images/oferta-de-black-friday-listing.svg`}
                alt="oferta de black friday"
              />
            </div>
          )}

          <div className="h-20px my-1.5 flex items-center">
            {hasVariationsInfo && (
              <ProductListVariations variations={variations_info} />
            )}
          </div>

          <Status product={product} />

          {reviews_count > 0 && (
            <div className="my-[4px]">
              <Ratings
                reviewsCount={reviews_count}
                ratingSummary={reviews_value}
                displayReviewsNo
                productUrl={`/${url_key}/cpd/${sku}/`}
              />
            </div>
          )}

          {hasFinancingOptions && (
            <div className="py-[6px] cursor-pointer w-fit">
              <ProductFinancing product={product} label="productCard" />
            </div>
          )}

          <div className="mb-0 mt-auto">
            <Price
              price={price}
              regularPrice={regular_price}
              lowestPrice={lowest_price}
              msrp={msrp_price}
              formatted
              discountType={discount_type}
              displayDiscount
              size="smaller"
              displayUnit={
                hasPricePerFactor && hasPriceUnit
                  ? product.price_unit.split("/")[1]
                  : false
              }
            />
          </div>

          {hasVariationsInfo && isSaleable && (
            <div className="mt-14px sm:mt-13px">
              <Button
                title="Selecteaza varianta"
                href={`/${url_key}/cpd/${sku}/`}
                variant="primary"
                display="block"
                isCatalog
              />
            </div>
          )}

          {(isSaleable || hasStorePickup) &&
            !hasVariationsInfo &&
            !isWestaco && <AddToCart product={product} isCatalog noMargin />}
        </>
      )}

      <div className="absolute top-10px left-11px lg:top-15px lg:left-16px flex flex-col justify-center items-center space-y-1.5">
        <AddToWishlist product={product} />
        <AddToCompare product={product} />
      </div>
    </div>
  );
};

export default AppleFeaturedCategoryProductCard;
